/**
 * component-product-sticky-atc.js
 * Custom Element <edj-product-sticky-atc>
 * Lot 3 Batch A — EDJ Shopify theme
 *
 * Pixel-perfect ref : page-produit-a-mobile.jsx 419-431
 *   - Apparaît quand le CTA principal sort du viewport (IntersectionObserver)
 *   - Mobile only : on n'instancie l'observer qu'en ≤ 767px
 *   - Click "Ajouter" → soumet implicitement le form principal du buy-box
 *     (via dispatchEvent submit sur le form data-edj-product-form le plus proche)
 *   - prefers-reduced-motion : pas de transition, simple toggle display
 *   - self-registering + idempotent
 */
(function () {
  'use strict';

  if (customElements.get('edj-product-sticky-atc')) return;

  const MOBILE_MQ = window.matchMedia('(max-width: 767px)');

  class EdjProductStickyAtc extends HTMLElement {
    connectedCallback() {
      this._setup();
      MOBILE_MQ.addEventListener?.('change', this._setup.bind(this));
    }

    disconnectedCallback() {
      this._teardown();
    }

    _setup() {
      this._teardown();
      if (!MOBILE_MQ.matches) return;

      const sel = this.dataset.targetSelector || '[data-edj-cta-row]';
      this.target = document.querySelector(sel);
      if (!this.target) return;

      this.removeAttribute('hidden');

      this.observer = new IntersectionObserver(
        ([entry]) => {
          // Show when the main CTA is no longer visible (out of viewport)
          this.classList.toggle('is-visible', !entry.isIntersecting);
        },
        { rootMargin: '0px 0px -60px 0px', threshold: 0 }
      );
      this.observer.observe(this.target);

      this.addBtn = this.querySelector('[data-edj-sticky-add]');
      this._onAddClick = this._onAddClick.bind(this);
      this.addBtn?.addEventListener('click', this._onAddClick);

      // Listen to variant:change to mirror state
      this._onVariant = this._onVariant.bind(this);
      document.addEventListener('edj:variant:change', this._onVariant);

      // Listen to cart:added to flash the success state
      this._onAdded = this._onAdded.bind(this);
      document.addEventListener('cart:added', this._onAdded);
    }

    _teardown() {
      this.observer?.disconnect();
      this.observer = null;
      this.addBtn?.removeEventListener('click', this._onAddClick);
      document.removeEventListener('edj:variant:change', this._onVariant);
      document.removeEventListener('cart:added', this._onAdded);
      this.classList.remove('is-visible');
    }

    _onAddClick(e) {
      e.preventDefault();
      // Forward to the main product form
      const form = document.querySelector('[data-edj-product-form]');
      if (!form) return;
      // Submit programmatically — the buy-box JS handles AJAX
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }
    }

    _onVariant(e) {
      const detail = e.detail || {};
      const v = detail.variant;
      if (!v) return;

      if (this.addBtn) this.addBtn.disabled = !v.available;

      const priceEl = this.querySelector('[data-edj-sticky-price]');
      const variantEl = this.querySelector('[data-edj-sticky-variant]');
      const labelEl = this.querySelector('[data-edj-sticky-label]');

      if (priceEl && typeof v.price === 'number') {
        priceEl.textContent = formatMoney(v.price);
      }
      if (variantEl && v.title) {
        variantEl.textContent = v.title;
      }
      if (labelEl) {
        labelEl.textContent = v.available ? 'Ajouter' : 'Épuisé';
      }
    }

    _onAdded() {
      if (!this.addBtn) return;
      this.addBtn.classList.add('is-added');
      const labelEl = this.querySelector('[data-edj-sticky-label]');
      const prev = labelEl?.textContent;
      if (labelEl) labelEl.textContent = '✓';
      setTimeout(() => {
        this.addBtn.classList.remove('is-added');
        if (labelEl && prev) labelEl.textContent = prev;
      }, 2000);
    }
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try { return window.Shopify.formatMoney(cents, '€{{amount_no_decimals_with_comma_separator}}'); } catch (e) {}
    }
    return (cents / 100).toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 }) + ' €';
  }

  customElements.define('edj-product-sticky-atc', EdjProductStickyAtc);
})();
